import CryptoJS from "crypto-js";
import Cookies from "js-cookie";

const secretKey = "19092002";

export const getDecryptedToken = () => {
  const encryptedToken = Cookies.get("token");
  if (!encryptedToken) return null;

  try {
    const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
    const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedToken) {
      Cookies.remove("token");
      return null;
    }

    return decryptedToken;
  } catch (error) {
    Cookies.remove("token");
    return null;
  }
};
